export default "__VITE_ASSET__B6Q$gy0l__"